export const pokemonGenerations = [
  {
    id: 1,
    place: 'Kanto',
    description: '1st Gen',
    pokemonsCounter: 151,
    offset: 0,
  },
  {
    id: 2,
    place: 'Johto',
    description: '2nd Gen',
    pokemonsCounter: 100,
    offset: 151,
  },
  {
    id: 3,
    place: 'Hoenn',
    description: '3rd Gen',
    pokemonsCounter: 135,
    offset: 251,
  },
  {
    id: 4,
    place: 'Sinnoh',
    description: '4th Gen',
    pokemonsCounter: 107,
    offset: 386,
  },
  {
    id: 5,
    place: 'Teselia',
    description: '5th Gen',
    pokemonsCounter: 156,
    offset: 493,
  },
  {
    id: 6,
    place: 'Kalos',
    description: '6th Gen',
    pokemonsCounter: 72,
    offset: 649,
  },
  {
    id: 7,
    place: 'Alola',
    description: '7th Gen',
    pokemonsCounter: 88,
    offset: 721,
  },
  {
    id: 8,
    place: 'Galar',
    description: '8th Gen',
    pokemonsCounter: 96,
    offset: 809,
  },
  {
    id: 9,
    place: 'Paldea',
    description: '9th Gen',
    pokemonsCounter: 103,
    offset: 905,
  },
];
